
import {Component, Vue} from "vue-property-decorator";
import {ICar} from "@/modules/Car/interfaces/car.interface";
import {IAuth} from "@/modules/Auth/interfaces/auth.interface";
import {IBook} from "@/interfaces/book.interface";
import {compareHelper} from "@/helpers/compareHelper";
import {IAppState} from "@/interfaces/app-state.interface";

@Component({})
export default class ParksField extends Vue {

  get storeState(): IAppState { return this.$store.state; }
  get formModel(): ICar.IEntity { return this.storeState.car.formData.formModel; }
  get startForm(): ICar.IEntity { return this.storeState.car.formData.startForm; }

  get userAccess(): IAuth.UserAccess { return this.storeState.auth.userAccess; }
  get parkValues() { return this.storeState.book.books[IBook.BookName.parks]; }

  get modelValue() { return this.formModel.parks; }
  set modelValue(value) {
    this.$store.commit('car/setFormProperty', {
      formName: 'formModel',
      name: 'parks',
      value
    });
  };

  compareArrays(arr1, arr2) {
    return compareHelper.compareArrays(arr1, arr2);
  }
}
